import { Layout, Typography } from 'antd';
import { FC } from 'react';

import { useAppSelector } from 'hooks';

import { WPMenuItem } from 'models';

import styles from './index.module.scss';

export const Footer = () => {
	const menu = useAppSelector((state) => state.settings.menu);

	const { footer } = menu;

	if (!footer?.contact) return null;

	return (
		<Layout.Footer className={styles.root}>
			<div className={styles.line} />
			<div className={styles.content}>
				<FooterColumn {...footer.legal} />

				<FooterColumn {...footer.about} />

				<FooterColumn {...footer.contact} />

				<FooterColumn {...footer.hours} />

				<div className={`${styles.column} ${styles.columnSocials}`}>
					<div className={styles.socials}>
						<Typography.Title level={5} className={styles.title}>
							{footer.follow.title}
						</Typography.Title>

						<div className={styles.icons}>
							{footer.follow.content?.map((item) => (
								<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
									<img src={item.icon} alt={item.url} />
								</a>
							))}
						</div>
					</div>

					<div className={styles.socials}>
						<Typography.Title level={5} className={styles.title}>
							{footer.community?.title}
						</Typography.Title>
						<div className={styles.icons}>
							{footer.community.content?.map((item) => (
								<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
									<img src={item.icon} alt={item.url} />
								</a>
							))}
						</div>
					</div>
				</div>
			</div>
			<div className={styles.text} dangerouslySetInnerHTML={{ __html: footer.copyright }} />
		</Layout.Footer>
	);
};

type Content = { content?: string };
type Menu = { menu?: WPMenuItem[] };
type Required = { title: string };

type FooterColumnProps = Required & Content & Menu;
const FooterColumn: FC<FooterColumnProps> = (data) => {
	return (
		<div className={styles.column}>
			<Typography.Title level={5} className={styles.title}>
				{data.title}
			</Typography.Title>
			{data.content && <div dangerouslySetInnerHTML={{ __html: data.content }} />}

			{data.menu?.map((item) => (
				<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
					{item.title}
				</a>
			))}
		</div>
	);
};
